var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',[_c('transition',{attrs:{"name":"fade"}},[_c(_vm.getStep(),{tag:"component",attrs:{"souscription":_vm.souscription,"user":_vm.user,"proprietaire":_vm.proprietaire,"params":_vm.params}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }